import React, { useState, useEffect } from "react";
import { Row, Col, Button, Modal } from 'react-bootstrap';
import "./OrderCompletedCancel.css";
import { useParams,Link,NavLink } from "react-router-dom";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { gettoastsuccess,gettoastwarning } from '../../Utils/Common';


const OrderCompletedCancel = () => {
	
	const [loading,setLoading] = useState(true);
	
	const { order_number } = useParams();
  const [show, setShow] = useState(false);

  //const [inputsm,setInputsm] = useState({id:'',ticket_id:'',ticket_name:'',ticket_number:'',first_name:'',last_name:'',age:'',email:'',mobile_number:'',qr_code:'',amount:0,status:0});
  
  const [persons, setPersons] = useState([]);

  const [ticket_ids, setTicket_ids] = useState([]);

  const [eventid, setEventid] = useState('');

  useEffect(() => {
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: 'smooth',
		});
    document.title = `Order Completed | Your Friend My Friend`;
    document.getElementById('bodywrap').className='ordercomplete';
	
	
	/* Start get order data */
		let formData = new FormData(); 
		formData.append('ticket_number', order_number);
		API.post('get_ticket_detail_for_web',formData)
			.then(response => {
				setLoading(false);
			if(response.data.status === false){
				
			}else{
				/*setInputsm({
					id:response.data.data.id,
					ticket_id:response.data.data.ticket_id,
					ticket_name:response.data.data.ticket_name,
					ticket_number:response.data.data.ticket_number,
					first_name:response.data.data.first_name,
					last_name:response.data.data.last_name,
					age:response.data.data.age,
					email:response.data.data.email,
					mobile_number:response.data.data.mobile_number,
					qr_code:response.data.data.qr_code,
					amount:response.data.data.amount,
					status:response.data.data.status,
				});*/
				
				setPersons(response.data.data.grouped_tickets.persons);

			}                  
		}).catch(error => {
			 
		});    
	 /* End get order data */
	
  },[order_number]);

const send_to_my_email = (event,ticket_number) => {
	event.preventDefault();
	setLoading(true);
	let formData = new FormData(); 
	formData.append('ticket_number', ticket_number);
	API.post('send_to_my_email',formData)
		.then(response => {
			setLoading(false);
		if(response.data.status === false){
			gettoastwarning(response.data.message,'');
		}else{
			gettoastsuccess(response.data.message,'');
		}                  
	}).catch(error => {
		 
	});  
}

const cancel_ticket = () => {
	
	setLoading(true);
	let formData = new FormData(); 
	formData.append('ticket_id', JSON.stringify(ticket_ids));
	formData.append('event_id', eventid);
	API.post('web_canceled',formData)
		.then(response => {
			setLoading(false);
		if(response.data.status === false){
			gettoastwarning(response.data.message,'');
			
		}else{
			var url_link='/order-completed-cancel/'+order_number;
			gettoastsuccess(response.data.message,url_link);
			
		}                  
	}).catch(error => {
		 
	});  
}

/* Start show delete varification modal */
const handleShow = (ticket_ids,event_id) => {	
	setTicket_ids(ticket_ids);
	setEventid(event_id);
	setShow(true);
}
/* End show delete varification modal */
const handleClose = () => setShow(false);
  

  return (
    <>
      <div className="container py-5">
        <div className="comple">
          <div className="row">
            <div className="col-md-12 order-first">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-right.png'}
                alt="modal-right"
                className="img-fluid"
              />
              <h3>Order completed</h3>
              <p>
                Thank you for your purchase—your ticket(s) are booked, and a
                confirmation email is on its way to your inbox! You will receive
                a copy of the tickets in your email.
              </p>
            </div>
          </div>	
			{persons &&
    		persons.map((val, index) => {
        return (
            <React.Fragment key={val.id || index}>


            	<div className="row d-flex align-items-center oc-main uio">
                  <div className="col-12 col-sm p-0 oc-rigth-loop">
 
                    <div class="row mx-0 py-3">
                      <div class="col px-0">
                        <h3>{val.first_name} {val.last_name}, {val.age}</h3>
                        <p class="mb-0">{val.email}</p>
                        <p class="mb-0">{val.mobile_number}</p>                        
                      </div>
                      <div class="col links sme-link">
                        <div className="orak">
                            <button onClick={(event) => send_to_my_email(event, val.ticket_number)}>
                                Send to my email
                            </button>
                        </div>
                      </div>
                    </div>
 										{/* Sub Tickets */}
                	{val.sub_tickets &&
                    val.sub_tickets.map((val1, key) => (
                    <div class="row mx-0 py-3">
                      <div class="col px-0">
                        <h3>{val1.first_name} {val1.last_name}, {val1.age}</h3>
                        <p class="mb-0">{val1.email}</p>
                        <p class="mb-0">{val1.mobile_number}</p>                        
                      </div>
                      <div class="col links sme-link">
                        <div className="orak">
                            <button onClick={(event) => send_to_my_email(event, val1.ticket_number)}>
                                Send to my email
                            </button>
                        </div>
                      </div>
                    </div>                    
 										))}
                  </div>
 						
                  <div className="col-12 col-sm-auto text-end py-3 cl-link links">
                    <div className="orak">
                    	 {val.status !== 2 ? (
                      <button className="oc-cancel" onClick={(event) => handleShow(val.ticket_ids,val.event_id)}>
                          Cancel ticket
                      </button>
                       ) : null}
                       {val.status === 2 ? (
                       	<p className="text-center text-danger">
                                Your ticket has been cancelled.
                            </p>
                    ) : null}

                    </div>                    
                  </div>
                </div>
            </React.Fragment>
        );
    })}
			
          

          <div className="row d-flex align-items-center text-center text-md-start apple"> 
            <div className="col-md-12 col-lg-6 p-0 mb-3 mb-lg-0">
              <h2> Get the app </h2>
              <p>
                Save your tickets and find your events in your account in the
                app!
              </p>
            </div>
            <div className="col-md-12 col-lg-6 p-0 text-center text-lg-end">
              <Link href="#">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-app.png'}
                  alt="App Store"
                  className="me-2"
                />
              </Link>
              <Link href="#">
                <img src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-google.png'} alt="Google Play" />
              </Link>
            </div>
			<div className="text-center mt-5">
              <Link className="btn brow-bu text-decoration-none" to="/upcoming-events">View More Events</Link>
            </div>
          </div>
        </div>
      </div>

{/* ========== Delete Popup Start ========== */}
		
		
		
		<Modal show={show} onHide={handleClose} centered >
        <div className="south cencel-pop-box" >
           <Modal.Header>
			  <h3 className="mdlttltxt">Are you sure you want to cancel?</h3>
		   </Modal.Header>
         
          <Modal.Body>
            <Row>
				 <Col className="btn-clr">
				 <NavLink to="#" onClick={cancel_ticket}><Button variant="">Yes</Button></NavLink>
				 </Col>
				 <Col className="btn-dv">
				 <NavLink to="#" onClick={handleClose}><Button variant="">No</Button></NavLink>
				 </Col>
			  </Row>
          </Modal.Body>
          
        </div>
      </Modal>
		
	  {/* ========== Delete Popup End ========== */}
      
	  {loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
    </>
  );
};

export default OrderCompletedCancel;
